import { brokerShowcase } from '../../../mocks/homeData';

export default function BrokersSection() {
  return (
    <section className="py-20 md:py-28 bg-zinc-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-4">
              Aggregating the Industry&apos;s Best
            </h2>
            <p className="text-zinc-500 text-lg max-w-xl mx-auto">
              LoadAPI.io pulls real-time data from the leading freight brokers in North America.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {brokerShowcase.map((broker) => (
              <div
                key={broker.shortName}
                className={`bg-white rounded-card p-6 shadow-lifted border-l-4 ${broker.color} hover:-translate-y-1 transition-transform duration-300`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${broker.bgPill}`}>
                    {broker.shortName}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-zinc-900 mb-2">
                  {broker.name}
                </h3>
                <p className="text-sm text-zinc-500 leading-relaxed">
                  {broker.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}